import React from 'react';
import moment from 'moment';
import DatePicker from 'react-bootstrap-date-picker';
import Select from 'react-select';
import 'whatwg-fetch';
import app_color_palette from 'src/data/style';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import ringAnim from 'src/images/anim/ring.svg';
import Card from 'src/components/Card';
import withAuth from 'src/hoc/withAuth';

const apiSearch = '/api/supportStatistics/membersTicketsByState';
const apiMemberGet = '/api/commercialStatistics/getMembers/';

class StatChartSupport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      employeeId: -1,
      dateStart: moment().subtract(7, 'day').format('YYYY-MM-DD'),
      dateEnd: moment().format('YYYY-MM-DD'),
      members: undefined,
      selectedMembers: [],
      data_chart: [{ name: 'Cloturés' }, { name: 'En cours' }, { name: 'Créés' }],
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleDateChange2 = this.handleDateChange2.bind(this);
    this.refreshSearch = this.refreshSearch.bind(this);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  handleInputSelectChange(val) {
    const value = val ? val['id'] : -1;

    if (!this.isMemberSelected(val)) {
      this.addMember(val);
    }
  }

  handleDateChange(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      dateStart: formattedValue, // Formatted String, ex: "11/19/2016"
    });
  }

  handleDateChange2(value, formattedValue) {
    this.setState({
      //value: value, // ISO String, ex: "2016-11-19T12:00:00.000Z"
      dateEnd: formattedValue, // Formatted String, ex: "11/19/2016"
    });
  }

  componentDidMount() {
    let search = {
      employeeId: this.state.employeeId,
      dateStart: this.state.dateStart,
      dateEnd: this.state.dateEnd,
    };
    ///////////////////////
    let queryURL = apiMemberGet;
    let json = { agencies: true, employees: true };
    queryURL += encodeURIComponent(JSON.stringify(json));
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data) {
            this.setState({
              members: data,
            });
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch employee list: \n' + error);
        }.bind(this)
      );
    ///////////////////////////////////////
    //this.refreshSearch(search);
  }

  refreshSearch(search) {
    this.setState({ pending: true });
    let queryURL = apiSearch;
    let data = 'data=' + encodeURIComponent(JSON.stringify(search));
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
        body: data,
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data) {
            this.refreshChartData(data);
          }
          this.setState({
            pending: false,
          });
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch stat-commercial search: ' + error);
        }.bind(this)
      );
  }

  refreshChartData(data) {
    let newData = [{ name: 'Cloturés' }, { name: 'En cours' }, { name: 'Créés' }];

    for (let i = 0; i < data.length; i++) {
      newData[0][data[i].member.label] = data[i].tickets_closed;
      newData[1][data[i].member.label] = data[i].tickets_on_going;
      newData[2][data[i].member.label] = data[i].tickets_created;
    }

    this.setState({ data_chart: newData });
  }

  shouldComponentUpdate(nextProps, nextState) {
    let search = {
      dateStart: moment(this.state.dateStart).format('YYYY-MM-DD'),
      dateEnd: moment(this.state.dateEnd).format('YYYY-MM-DD'),
      members: this.state.selectedMembers,
    };

    if (nextState.selectedMembers.toString() !== this.state.selectedMembers.toString()) {
      search.members = nextState.selectedMembers;
      this.refreshSearch(search);
    } else if (this.state.selectedMembers.length !== 0 && nextState.dateStart != this.state.dateStart) {
      search.dateStart = moment(nextState.dateStart).format('YYYY-MM-DD');
      this.refreshSearch(search);
    } else if (this.state.selectedMembers.length !== 0 && nextState.dateEnd != this.state.dateEnd) {
      search.dateEnd = moment(nextState.dateEnd).format('YYYY-MM-DD');
      this.refreshSearch(search);
    }

    return true;
  }

  removeMember(index) {
    this.setState({
      selectedMembers: this.state.selectedMembers.filter(function (person, i) {
        return index !== i;
      }),
    });
  }

  addMember(val) {
    if (this.state.selectedMembers.length >= 8) {
      this.props.openToast(false, 'Limite de membre atteinte');
    } else {
      this.setState({
        selectedMembers: this.state.selectedMembers.concat([val]),
      });
    }
  }

  isMemberSelected(val) {
    let res = false;
    for (let i = 0; i < this.state.selectedMembers.length; i++) {
      if (this.state.selectedMembers[i].id == val.id && this.state.selectedMembers[i].type == val.type) {
        res = true;
        break;
      }
    }
    return res;
  }

  render() {
    const { members } = this.state;
    const { selectedMembers } = this.state;
    const { data_chart } = this.state;

    let noMembers =
      this.state.selectedMembers && this.state.selectedMembers.length === 0 ? (
        <span>Aucun membre sélectionné.</span>
      ) : (
        ''
      );

    return (
      <Card>
        <div id='stat-container'>
          <div id='stat-aside'>
            <div id='stat-aside-header'>
              <h4>
                <span className='icon icon-plus' />
                Membres
              </h4>
              <Select
                className='select-stock-search form-control'
                name='employeeId'
                value={this.state.employeeId}
                labelKey={'label'}
                valueKey={'id'}
                options={members}
                onChange={this.handleInputSelectChange}
                noResultsText={'Aucun résultat'}
                placeholder={'Ajouter un membre'}
                clearValueText={'Supprimer'}
              />
            </div>
            <div id='stat-aside-list'>
              {selectedMembers.map((data, i) => (
                <div key={i} className='stat-aside-list-row alignHorizontal'>
                  <div className='stat-row-square' style={{ backgroundColor: app_color_palette[i] }} />
                  <span>{data.label}</span>
                  <button onClick={() => this.removeMember(i)} type='button' className='btn btn-sm btn-outline-success'>
                    <span className='icon icon-cross' />
                  </button>
                </div>
              ))}
              {noMembers}
            </div>
          </div>

          <div id='stat-content'>
            <div id='stat-content-header' className='alignHorizontal'>
              <h2>
                Support
                {this.state.pending && <img style={{ maxHeight: 25 }} src={ringAnim} />}
              </h2>
              <div id='stat-aside-header-dates' className='alignHorizontal'>
                <DatePicker
                  calendarContainer={this}
                  name='dateStart'
                  value={this.state.dateStart}
                  onChange={this.handleDateChange}
                  dateFormat='YYYY-MM-DD'
                />
                <span className='icon icon-arrow-right' />
                <DatePicker
                  calendarContainer={this}
                  name='dateEnd'
                  value={this.state.dateEnd}
                  onChange={this.handleDateChange2}
                  dateFormat='YYYY-MM-DD'
                />
              </div>
            </div>
            <div id='stat-chart'>
              <ResponsiveContainer width='100%' height='100%'>
                <BarChart data={data_chart} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid strokeDasharray='3 3' />
                  <XAxis dataKey='name' />
                  <YAxis />
                  <Tooltip />
                  <Legend />

                  {selectedMembers.map((data, i) => (
                    <Bar key={i} dataKey={data.label} stackId='a' fill={app_color_palette[i]} />
                  ))}
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

export default withAuth(StatChartSupport);
